// extracted by mini-css-extract-plugin
export default {"link":"FfZLkc","waybetter":"gsgBmw","waybetterStandard":"qdX2O3","runkeeper":"VsRB6p","facebook":"fzvmbY","landing":"o2AqSo","membership":"yzJPgm"};